import React, { useState, useEffect } from "react";
import updateHead from "../../utils/helper/updatePageHead";
import { Link } from "react-router-dom";
import { useUser } from "../../utils/contexts/userContext";

export default function NavBar() {
    const cssPath = "/style/navbar.css";

    const [dropDown, setDropDown] = useState(false)
    const { user } = useUser();

    const [navWidth, setNavWidth] = useState(window.innerWidth)
    window.addEventListener('resize', () => { setNavWidth(window.innerWidth) })

    useEffect(() => {
        const handleClick = (e) => {
            if (e.target.id !== "dropdown-nav") {
                setDropDown(false)
            }
        }
        document.body.addEventListener('click', handleClick)

        return () => document.body.removeEventListener('click', handleClick)
    }, [])

    return (
        <>
            {updateHead({ cssPaths: [cssPath] })}
            <div className="navbar-container">
                <Link className="navbar-company-icon" to="/">
                    <img src="/assets/logo_dips.svg" className="icon" alt="company logo" style={{ width: '100px' }} />
                </Link>
                <div className="navbar-container-leftpart">
                    <Link className="navbar-menu-item" to="/services">Prestations</Link>
                    <Link to="/products" className="navbar-menu-item">Produits</Link>
                    {navWidth > 1050 && <div className="navbar-menu-item" onClick={() => setDropDown(!dropDown)} id="dropdown-nav">
                        <span style={{ paddingRight: '10px' }} id="dropdown-nav">Solutions</span>
                        <img
                            src="/assets/angle-right-solid.svg"
                            className={dropDown ? "dropdowned" : ""}
                            id="dropdown-nav" style={{ height: '12px' }}
                            alt="dropdown" />
                        {dropDown &&
                            (<ul className="navbar-container-dropdown">
                                <li key='navdroplib'>
                                    <Link to="/library" className="navbar-dropdown-menu-item">
                                        <img src="/assets/archive.png" alt='library' className="icon" style={{ width: '18px', padding: '0 15px 0 0' }} />
                                        Service Peasys
                                    </Link>
                                </li>
                                <li key='navdropprod'>
                                    <Link className="navbar-dropdown-menu-item" to="/docs">
                                        <img src="/assets/box.png" alt='products' className="icon" style={{ width: '18px', padding: '0 15px 0 0' }} />
                                        Documentation
                                    </Link>
                                </li>
                            </ul>)}
                    </div>}
                    {navWidth > 1150 && <Link className="navbar-menu-item" to="/pricing">Tarifs</Link>}
                    {navWidth > 1250 && <Link className="navbar-menu-item" to="/company">Entreprise</Link>}
                </div>
                <div className="navbar-container-rightpart">
                    {user._id ?
                        (<Link className="navbar-menu-item navbar-account-info-container" to="/account">
                            {/*<a href="https://fr.freepik.com/search?format=search&freeSvg=free&last_filter=freeSvg&last_value=free&query=company&type=icon">Icône de UIcons</a>*/}
                            <img alt="profile" src="/assets/company.svg" />
                            <h6>{user.firstname} {user.lastname}</h6>
                        </Link>) :
                        (<>
                            <Link
                                className="navbar-menu-item login"
                                to="/register">s'inscrire</Link>
                            <span className="login-register-separate">|</span>
                            <Link
                                className="navbar-menu-item register"
                                to="/login">se connecter</Link>
                        </>)}
                </div>
            </div>
        </>
    )
}